import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-contributors',
  templateUrl: './contributors.component.html',
  styleUrls: ['./contributors.component.scss']
})
export class ContributorsComponent implements OnInit {
  user: any;
  peopleLink: string;
  path = "../../../../assets/images/"

  constructor() { }

  @Input() contributorList: any;
  ngOnInit(): void {    
    for(let i=0;i<this.contributorList.length;i++)
    {
      if(this.contributorList[i].Image == 'Not Filled') this.contributorList[i].Image ="User.svg";
    }
    // if(this.contributorList[0].Image == 'Not Filled') this.contributorList[0].Image ="User.svg";    
    
  }

  navigateToPeoplePage(empId: any) {
    (empId.indexOf("@") != -1) ? this.user = empId.slice(0, empId.indexOf("@")).trim() : this.user = empId;
    this.peopleLink = "https://people.accenture.com/People/user/" + this.user;
    window.open(this.peopleLink, "_blank");
  }

}
